import React, { useState, useEffect } from "react";
import { Button, Menu, Typography, Avatar } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  HomeOutlined,
  MoneyCollectOutlined,
  BulbOutlined,
  FundOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import icon from "../images/cryptocurrency.png";
const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState(true);
  const [screenSize, setScreenSize] = useState(undefined);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 800) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);
  const { pathname } = useLocation();
  let path = "/";
  if (pathname.includes("/crypto")) {
    path = "/cryptocurrencies";
  } else if (pathname === "/") {
    path = "/home";
  } else {
    path = pathname;
  }

  return (
    <div className="nav-container">
      <div className="logo-container">
        <Avatar src={icon} size="large" />
        <Typography.Title level={2} className="logo">
          <Link to="/">ryptoLib</Link>
        </Typography.Title>
        <Button
          className="menu-control-container"
          onClick={() => {
            setActiveMenu((isActive) => !isActive);
          }}
        >
          <MenuOutlined />
        </Button>
      </div>
      {activeMenu && (
        <Menu
          theme="dark"
          defaultSelectedKeys={["/home"]}
          selectedKeys={[path]}
        >
          <Menu.Item icon={<HomeOutlined />} key="/home">
            <Link to="/"> Home </Link>
          </Menu.Item>
          <Menu.Item icon={<FundOutlined />} key="/cryptocurrencies">
            <Link to="/cryptocurrencies"> Cryptocurrencies </Link>
          </Menu.Item>
          <Menu.Item icon={<MoneyCollectOutlined />} key="/exchanges">
            <Link to="/exchanges"> Excahnges </Link>
          </Menu.Item>
          <Menu.Item icon={<BulbOutlined />} key="/news">
            <Link to="/news"> News </Link>
          </Menu.Item>
        </Menu>
      )}
    </div>
  );
};

export default Navbar;
